export enum FormFieldLabel {
  ASSIGNMENT_INSTRUCTIONS = 'Assignment Instructions'
}

export const TOOLTIP_ACCESSIBLE_NAME = 'Information about Instructions';
